module.exports = __webpack_public_path__ + "static/media/Thumbnail.1c6c2ed8.tiff";